import React from 'react';
import PropTypes from 'prop-types';
import { Box, Text } from 'grommet';
import GeoHeatmap from '../Cyclops/GeoHeatmap';

const GeoHeatmapPanel = ({
  title,
  subtitle = null,
  data,
  small,
  primaryText = 'var(--page-primary-text)',
  secondaryText = 'var(--page-secondary-text)',
}) => (
  <Box direction="column" gap="1rem">
    <Box direction="column" gap="0.5rem">
      <Text color={primaryText} size="1rem" weight={700}>{title}</Text>
      {subtitle && <Text color={secondaryText} size="0.8rem">{subtitle}</Text>}
    </Box>
    <Box height={small ? '22rem' : '30rem'}>
      <GeoHeatmap showTooltip data={data} />
    </Box>
  </Box>
);

GeoHeatmapPanel.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  data: PropTypes.object.isRequired,
  small: PropTypes.bool.isRequired,
  primaryText: PropTypes.string,
  secondaryText: PropTypes.string,
};

export default GeoHeatmapPanel;
